import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CMEllipsis } from "./ellipsis.styles";
import { parseHTML } from "../../Utils/common.utils";

const Ellipsis = ({ text, limit, tail, closedTail, redirect, src, ...props }) => {
  const [showMore, setShowMore] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleShowMore = () => {
    if (redirect && src) {
      navigate(src);
    } else {
      setShowMore(prev => !prev);
    }
  };

  const safeText = typeof text === 'string' ? text : '';

  const getPlainText = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const plainText = getPlainText(safeText);
  const limitedText = Array.from(plainText).slice(0, limit).join('');

  const safeParseHTML = (html) => {
    try {
      return parseHTML(html);
    } catch (e) {
      console.error("Error al parsear HTML:", e);
      return html;
    }
  };

  const renderPreview = () => (
    <>
      {limitedText}
      <span className="ellipsis-tail" onClick={handleShowMore} >
        {tail || 'more...'}
      </span>
    </>
  );

  const renderFull = () => (
    <>
      {safeParseHTML(safeText)}
      <span className="ellipsis-tail" onClick={handleShowMore}>
        {closedTail || 'less...'}
      </span>
    </>
  );

   useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const expand = searchParams.has("expand");

    if (expand) {
      setShowMore(true);
    }
  }, [location.search]);

  return (
    <CMEllipsis {...props} style={{ wordBreak: "break-word" }}>
      {plainText.length > limit
        ? (showMore ? renderFull() : renderPreview())
        : safeParseHTML(safeText)}
    </CMEllipsis>
  );
};

export default Ellipsis;
